import { SNACKBAR_TYPES } from '@/utils/constants';

export default {
  name: 'Snackbar',
  data() {
    return {
      duration: 5000,
      id: null,
      msg: '',
      position: 'top',
      showClose: false,
      showSnackbar: false,
      title: '',
      type: SNACKBAR_TYPES.INFO,
    };
  },
  computed: {
    color() {
      const colorMapping = {
        [SNACKBAR_TYPES.ERROR]: 'danger',
        [SNACKBAR_TYPES.INFO]: 'warning',
        [SNACKBAR_TYPES.SUCCESS]: 'success',
      };
      return colorMapping[this.type] || 'primary';
    },
    defaultData() {
      return {
        duration: 3000,
        id: null,
        msg: '',
        position: 'top',
        showClose: true,
        showSnackbar: false,
        title: '',
        type: SNACKBAR_TYPES.INFO,
      };
    },
    icon() {
      const iconMapping = {
        [SNACKBAR_TYPES.ERROR]: 'icon-error-round-circle',
        [SNACKBAR_TYPES.INFO]: 'icon-info-round-circle',
        [SNACKBAR_TYPES.SUCCESS]: 'icon-success-round-circle',
      };
      return iconMapping[this.type] || 'icon-cross';
    },
  },
  mounted() {
    this.showSnackbar = true;
    setTimeout(() => {
      this.close();
    }, this.duration);
  },
  methods: {
    close() {
      const snackbar = document.getElementById(`snackbar-${this.id}`);
      if (snackbar) {
        snackbar.remove();
        Object.assign(this.$data, this.defaultData);
      }
    },
  },
};
